import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'formly-mask-input',
    template: `
      <mat-form-field class="w-full">
        <mat-label>{{props.label}}</mat-label>
        <input
          matInput
          [mask]="props.mask"
          thousandSeparator=","
          [formControl]="formControl"
          [formlyAttributes]="field"
          [placeholder]="props.placeholder"
          [dropSpecialCharacters]="props.dropSpecialCharacters"
          [required]="props.required"
          [allowNegativeNumbers]="props.allowNegativeNumbers || false"
          [suffix]="props.suffix || ''"
          [prefix]="props.prefix || ''"
        />
      </mat-form-field>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, NgxMaskDirective, FormsModule, ReactiveFormsModule, FormlyModule]
})
export class MaskInputComponent extends FieldType<FieldTypeConfig>  {

}
